export const columns = [
  {
    field: "first_name",
    header: "Name",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "first_name")} className="">
          <p>{row?.first_name + " " + row?.last_name}</p>
          {/* <p className="w-[6rem]">
            {moment(row?.order_date).utc().format("DD MMM YYYY hh:mma")}
          </p> */}
        </div>
      </>
    ),
  },
  {
    field: "referral_code",
    header: "Referral code",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "referral_code")} className="">
          <p>{row?.referral_code}</p>
        </div>
      </>
    ),
  },
  {
    field: "country",
    header: "Country",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "country")} className="">
          <p>{row?.country?.name||""}</p>
        </div>
      </>
    ),
  },
  {
    field: "city",
    header: "City",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "city")} className="">
          <p>{row?.city?.name}</p>
        </div>
      </>
    ),
  },
  {
    field: "referral_amount",
    header: "Referral Amount",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "referral_amount")}
          className=""
        >
          <p>{row?.referral_amount}</p>
        </div>
      </>
    ),
  },
  {
    field: "referral_count",
    header: "Referral Count",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "referral_count")}
          className=""
        >
          <p>{row?.referral_count}</p>
        </div>
      </>
    ),
  },
  {
    field: "is_active",
    header: "Active status",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "referral_count")}
          className=""
        >
          <p>{row?.is_active ? "Active" : "Expired"}</p>
        </div>
      </>
    ),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  // enum: ['Store', 'Product', 'Category', 'Sub Category'],
  {
    filterType: "Promo Code for",
    inputName: "status",
    options: [
      {
        name: "Approved",
        code: "Approved",
      },
    ],
  },
];
